import Vue from 'vue'
import Router from 'vue-router'
import main from '@/views/main/index'
import seckill from '@/views/seckill/seckill'
import proprietary from '@/views/proprietary/index'
import news from '@/views/news/list'
import newsDetails from '@/views/news/details'
import volume from '@/views/volume/index'
import lensMod from '@/views/lensMod/index'


Vue.use(Router)

const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
  path: '/',
  name: 'main',
  component: main,
  meta: {
    title: '骏芯电子商城'
  },
  children: []
}, {
  // 登录
  path: '/login/login',
  name: 'login',
  component: () => import("../views/login/login"),
}, {
  // 忘记密码
  path: '/login/resetpwd',
  name: 'resetpwd',
  component: () => import("../views/login/resetpwd"),
}, {
  path: '/seckill/index',
  name: 'seckill',
  component: seckill
}, {
  path: '/proprietary/index/:name/:title/:pid/:topid',
  name: 'proprietary',
  component: proprietary
}, {
  path: '/news/list/:id',
  name: 'news',
  component: news
},
{
  // 领卷中心
  path: '/volume/index',
  name: 'volumeIndex',
  component: () => import("../views/volume/index"),
},

{
  // 镜头模组
  path: '/lensMod',
  name: 'lensMod',
  component: lensMod
},
{
  path: '/news/details/:id',
  name: 'newsDetails',
  component: newsDetails
},
{
  // Goods
  path: '/main/goods/:data',
  name: 'goods',
  component: () => import("../views/main/goods"),
},
{
  // shopCar
  path: '/shop/shopCar',
  name: 'car',
  meta: { requiresAuth: true },
  component: () => import("../views/shop/car"),
},
{
  // 结算
  path: '/shop/account:data',
  name: 'account',
  meta: { requiresAuth: true },
  component: () => import("../views/shop/account"),
},
{
  // 支付
  path: '/shop/apply:data',
  name: 'apply',
  meta: { requiresAuth: true },
  component: () => import("../views/shop/apply"),
},
{
  // vx支付
  path: '/shop/wx/:data/:order_id',
  name: 'wx',
  meta: { requiresAuth: true },
  component: () => import("../views/shop/wx"),
}, {
  // zfb支付
  path: '/shop/zfb:data',
  name: 'zfb',
  meta: { requiresAuth: true },
  component: () => import("../views/shop/zfb"),
}, {
  // personal
  path: '/personal/index',
  name: '/personal/index',
  component: () => import("../views/personal/index"),
}, {
  // 找回手机
  path: '/personal/find',
  name: 'find',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/find"),
},
{
  // 个人优惠券
  path: '/personal/coupon',
  name: 'coupon',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/coupon"),
}, {
  // 个人积分
  path: '/personal/integral',
  name: 'coupon',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/integral"),
},
{
  // 足迹
  path: '/personal/footprint',
  name: 'footprint',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/footprint"),
},
{
  // 个人中心左边组件
  path: '/personal/left',
  name: 'left',
  component: () => import("../components/personal/personal-left"),
},
{
  // 增加地址
  path: '/personal/addAddress',
  name: 'addAddress',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/addAddress"),
},
{
  // 订单
  path: '/personal/order',
  name: 'order',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/order"),
},
{
  // 找回密码
  path: '/personal/findCode',
  name: 'findCode',
  component: () => import("../views/personal/findCode"),
},
{
  // 新品推荐
  path: '/proprietary/newsGoods',
  name: 'newsGoods',
  component: () => import("../views/proprietary/newsGoods"),
},
{
  // 新品推荐详情
  path: '/proprietary/newsGoodsInfo/:id',
  name: 'newsGoodsInfo',
  component: () => import("../views/proprietary/newsGoodsInfo"),
},
{
  // 新品推荐详情
  path: '/news/newsInfo/:id/:title/:name',
  name: 'newsInfo',
  component: () => import("../views/news/newsInfo"),
},
{
  // 爆款推荐hotCake
  path: '/proprietary/hotCake/:name/:title/:pid/:topid',
  name: 'hotCake',
  component: () => import("../views/proprietary/hotCake"),
},
{
  // 全部商品
  path: '/proprietary/allProducts/:name/:title/:pid/:topid',
  name: 'allProducts',
  component: () => import("../views/proprietary/allProducts"),
},
{
  // 成品方案
  path: '/proprietary/endProduct/:name/:title',
  name: 'endProduct',
  component: () => import("../views/proprietary/endProduct"),
},
{
  // 积分
  path: '/volume/jifeng',
  name: 'jifeng',
  component: () => import("../views/volume/jifeng"),
},
{
  // 代理
  path: '/volume/agent',
  name: 'agent',
  component: () => import("../views/volume/agent"),
}, {
  // 订单详情
  path: '/personal/orderInfo/:id',
  name: 'orderInfo',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/orderInfo"),
}, {
  // 发票列表
  path: '/personal/myFp',
  name: 'myFp',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/myFp"),
}, {
  // 订单支付成功
  path: '/personal/orderSucceeded',
  name: 'orderSucceeded',
  meta: { requiresAuth: true },
  component: () => import("../views/personal/orderSucceeded"),
}, {
  //
  path: '/news/video',
  name: 'video',
  component: () => import("../views/news/video"),
},
{
  //
  path: '/news/feedback',
  name: 'feedback',
  component: () => import("../views/news/feedback"),
},

{
  // 登录
  path: '/login/signIn',
  name: 'signIn',
  component: () => import("../views/login/signIn"),
},

]


const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  }
})

// 路由拦截，判断是否需要登录
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }
  // 通过requiresAuth判断当前路由导航是否需要登录
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let token = localStorage.getItem('token')
    // 若需要登录访问，检查是否为登录状态
    if (!token) {
      next({
        path: '/login/signIn',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js